import {useDispatch} from 'react-redux'
import {useState,useEffect} from 'react'
import Modal from 'react-bootstrap/Modal'
import DatePicker from 'react-datepicker'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { useDebounceCallback } from '@react-hook/debounce'
import {
	setAddDataModal
} from './slice'
import {
	useAddDataModal,
	useAddDataModalToggle,
	useMetricProgressLogger,
	useDateFilteredProgressData
} from './hooks'
import {secondsToTimeObj} from '../../util/datetime'
import DataInput from './DataInput'

import {dateToYMD} from '../../util/datetime'

const DataPointEditor = ({date,metricId})=>{
	
	const data = useDateFilteredProgressData(metricId,date)

	const {statusLog} = useMetricProgressLogger()

	const [localValue,setLocalValue] = useState(
		data.dateStat
		? data.dateStat.value
		: ''
	)

	const [localNotes,setLocalNotes] = useState(
		data.dateStat
		? data.dateStat.notes
		: ''
	)

	const hasValue = Boolean(data.dateStat.value)

	const debouncedLog = useDebounceCallback( payload => {
		if (hasValue&&!window.confirm('Would you like to replace the existing data for this date?') ) return
		statusLog(payload)
	},2000)

	const handleSave = () => {
		const notes = localNotes
		const payload = {
			overwrite_existing:true,
			metric_id:metricId,
			date,
			notes,
		}
		//time units require special handling
		if (data.unit_id === 2) {
			const timeObj = secondsToTimeObj(localValue)
			payload.hours = timeObj.hours
			payload.minutes = timeObj.minutes
			payload.seconds = timeObj.seconds
		} else {
			payload.value = localValue
		}
		statusLog(payload)
	}

	useEffect(()=>{
		setLocalValue( 
			data.dateStat
			? data.dateStat.value
			: ''
		)

		setLocalNotes( 
			data.dateStat
			? data.dateStat.notes
			: ''
		)
	},[date,metricId])

	return (
		<div>
			{data.assessment_name} {data.unit!=='None'&&`(${data.unit})`}
			<div className="d-flex">
				<DataInput
					value={localValue}
					onChange={setLocalValue}
					unit={data.unit_id}
				/>
				<Form.Control
					onChange={e=>{
						setLocalNotes(e.target.value)
					}}
					style={{height:'38px',minHeight:'38px'}}
					value={localNotes}
					placeholder="notes"
					className="ml-1"
					as="textarea"
				/>
				<Button 
					style={{flex:'0 0 auto'}}
					className="ml-1" 
					variant="outline-success"
					onClick={handleSave}
				>
					<span className="d-none d-md-inline">Save</span> <i className="fa fa-save"/>
				</Button>
			</div>
		</div>
	)
}

const AddDataModal = ()=>{
	const dispatch = useDispatch()
	const {show,date,categoryGroups} = useAddDataModal()

	const handleDateSelect = selected => {
		dispatch(
			setAddDataModal({
				date:dateToYMD(selected)
			})
		)
	}

	const toggle = useAddDataModalToggle()

	return (
		<Modal show={show} onHide={toggle} size="lg">
			<Modal.Header>
				Add Progress Data <Button onClick={toggle} variant="outline-danger" size="sm">Close</Button>
			</Modal.Header>
			<Modal.Body>
				<strong className="d-block">
					Date
				</strong>
				<DatePicker
					onChange={handleDateSelect}
					selected={new Date(`${date}T00:00:00`)}
					customInput={<Form.Control size="sm"/>}
				/>
				<div>
					<small className="text-info">
						<i className="fa fa-info-circle mr-2"/>
						Data will automatically populate for metrics that already have data for the selected date.
					</small>
				</div>
				<hr className="mt-2" />
				{categoryGroups.map(group=>(
					<div className="mt-4">
						<strong>{group.name}</strong>
						{group.metrics.map(id=>(
							<DataPointEditor date={date} metricId={id}/>
						))}
					</div>
				))}
				<div className="d-flex mt-2">
					<Button className="ml-auto" onClick={toggle} variant="outline-danger" size="sm">Close</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default AddDataModal